import { ThemeSystemColorPalette, ThemeM3SemanticColorPalette  } from '../../colors.model';

export const SystemColors: ThemeSystemColorPalette = {
  transparent: 'transparent',
  current: 'currentColor',
  inherit: 'inherit',
  dark: 'black',
  light: 'white',
};

export const M3Colors: ThemeM3SemanticColorPalette = {
  // Primary
  'm3-primary': 'var(--mat-sys-primary)',
  'm3-on-primary': 'var(--mat-sys-on-primary)',
  'm3-primary-container': 'var(--mat-sys-primary-container)',
  'm3-on-primary-container': 'var(--mat-sys-on-primary-container)',
  'm3-primary-fixed': 'var(--mat-sys-primary-fixed)',
  'm3-on-primary-fixed': 'var(--mat-sys-on-primary-fixed)',
  'm3-primary-fixed-dim': 'var(--mat-sys-primary-fixed-dim)',
  'm3-on-primary-fixed-variant': 'var(--mat-sys-on-primary-fixed-variant)',

  // Secondary
  'm3-secondary': 'var(--mat-sys-secondary)',
  'm3-on-secondary': 'var(--mat-sys-on-secondary)',
  'm3-secondary-container': 'var(--mat-sys-secondary-container)',
  'm3-on-secondary-container': 'var(--mat-sys-on-secondary-container)',
  'm3-secondary-fixed': 'var(--mat-sys-secondary-fixed)',
  'm3-on-secondary-fixed': 'var(--mat-sys-on-secondary-fixed)',
  'm3-secondary-fixed-dim': 'var(--mat-sys-secondary-fixed-dim)',
  'm3-on-secondary-fixed-variant': 'var(--mat-sys-on-secondary-fixed-variant)',

  // Tertiary
  'm3-tertiary': 'var(--mat-sys-tertiary)',
  'm3-on-tertiary': 'var(--mat-sys-on-tertiary)',
  'm3-tertiary-container': 'var(--mat-sys-tertiary-container)',
  'm3-on-tertiary-container': 'var(--mat-sys-on-tertiary-container)',
  'm3-tertiary-fixed': 'var(--mat-sys-tertiary-fixed)',
  'm3-on-tertiary-fixed': 'var(--mat-sys-on-tertiary-fixed)',
  'm3-tertiary-fixed-dim': 'var(--mat-sys-tertiary-fixed-dim)',
  'm3-on-tertiary-fixed-variant': 'var(--mat-sys-on-tertiary-fixed-variant)',

  // Error
  'm3-error': 'var(--mat-sys-error)',
  'm3-on-error': 'var(--mat-sys-on-error)',
  'm3-error-container': 'var(--mat-sys-error-container)',
  'm3-on-error-container': 'var(--mat-sys-on-error-container)',

  // Background
  'm3-background': 'var(--mat-sys-background)',
  'm3-on-background': 'var(--mat-sys-on-background)',

  // Surface
  'm3-surface': 'var(--mat-sys-surface)',
  'm3-on-surface': 'var(--mat-sys-on-surface)',
  'm3-surface-variant': 'var(--mat-sys-surface-variant)',
  'm3-on-surface-variant': 'var(--mat-sys-on-surface-variant)',
  'm3-surface-tint': 'var(--mat-sys-surface-tint)',

  // Surface containers
  'm3-surface-dim': 'var(--mat-sys-surface-dim)',
  'm3-surface-bright': 'var(--mat-sys-surface-bright)',
  'm3-surface-container-lowest': 'var(--mat-sys-surface-container-lowest)',
  'm3-surface-container-low': 'var(--mat-sys-surface-container-low)',
  'm3-surface-container': 'var(--mat-sys-surface-container)',
  'm3-surface-container-high': 'var(--mat-sys-surface-container-high)',
  'm3-surface-container-highest': 'var(--mat-sys-surface-container-highest)',

  // Outline & misc
  'm3-outline': 'var(--mat-sys-outline)',
  'm3-outline-variant': 'var(--mat-sys-outline-variant)',
  'm3-shadow': 'var(--mat-sys-shadow)',
  'm3-scrim': 'var(--mat-sys-scrim)',

  // Inverse
  'm3-inverse-surface': 'var(--mat-sys-inverse-surface)',
  'm3-inverse-on-surface': 'var(--mat-sys-inverse-on-surface)',
  'm3-inverse-primary': 'var(--mat-sys-inverse-primary)',
};
